import { pxToRem } from "@utils";
import styled from "styled-components";
import { StyledIllustrationProps } from "./types";

export const StyledIllustration = styled.svg<StyledIllustrationProps>`
  fill: none;
  width: ${({ $size }) => $size || pxToRem(100)};
  height: ${({ $size }) => $size || pxToRem(100)};
`;
